import request from '@/utils/request'

// 获取博客侧边栏
export function blog_sidebar() {
	return request({
		url: '/information/blog/sidebar',
		method: 'get',
	})
}

// 获取博客列表
export function blog_list(params) {
	return request({
		url: '/information/blog/list',
		method: 'post',
		data: params,
	})
}

// 获取博客详情
export function blog_detail(params) {
	return request({
		url: '/information/blog/detail',
		method: 'get',
		params: params,
	})
}
